import Api from '../Api';
import { errorNotification } from '../Snackbar';

export const setSampleFiles =
  (productIndex, file, isRemove) => async dispatch =>
    dispatch({
      type: 'SET_SAMPLE_FILES',
      payload: { productIndex, file, isRemove: Boolean(isRemove) },
    });

export const deleteSampleProduct = productIndex => async dispatch =>
  dispatch({
    type: 'DELETE_PRODUCT_SAMPLE',
    payload: { productIndex },
  });

export const clearSampleFiles = () => {
  return {
    type: 'CLEAR_SAMPLE_FILES',
  };
};

export const getSamples = query => async dispatch => {
  const { data } = await Api.get(`/samples`, query);

  dispatch({
    type: 'FETCH_SAMPLES',
    payload: data,
  });
};

export const clearSamples = () => {
  return {
    type: 'CLEAR_SAMPLES',
  };
};

export const getSample = id => async dispatch => {
  const { data } = await Api.get(`/samples/${id}`);

  dispatch({
    type: 'FETCH_SAMPLE',
    payload: data,
  });
};

export const clearSample = () => {
  return {
    type: 'CLEAR_SAMPLE',
  };
};

export const getSamplePreview = id => async dispatch => {
  try {
    const { data } = await Api.get(`/samples/preview/${id}`);

    dispatch({
      type: 'FETCH_SAMPLE_PREVIEW',
      payload: data,
    });
  } catch (error) {
    errorNotification(error);
  }
};

export const clearSamplePreview = () => {
  return {
    type: 'CLEAR_SAMPLE_PREVIEW',
  };
};

export const getSampleItemsToIssue = id => async dispatch => {
  try {
    const { data } = await Api.get(`/samples/itemstoissue/${id}`);

    dispatch({
      type: 'FETCH_SAMPLE_ITEMS_TO_ISSUE',
      payload: data,
    });
  } catch (error) {
    errorNotification(error);
  }
};

export const clearSampleItemsToIssue = () => {
  return {
    type: 'CLEAR_SAMPLE_ITEMS_TO_ISSUE',
  };
};
